export default "__VITE_ASSET__72bf6f41__"